import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import StatusDialog from "./StatusDialog";
import ReviewDrawer from "./ReviewDrawer";
import { useExam } from "../../contexts/ExamContext";

const ExamHeader = ({exam, startedAt, timeLeft, appendTo, onFinish }) => {
    const { resetExam, persistOpenAnswer, answers, studentExamId, questionHtmlOverrides, optionHtmlOverrides, disabledOptions } = useExam();
    const [now, setNow] = useState(() => new Date());
    const [showHeader, setShowHeader] = useState(true);
    const [showStatus, setShowStatus] = useState(false);
    const [showReview, setShowReview] = useState(false);
    const [showFinishConfirm, setShowFinishConfirm] = useState(false);

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    const formatHMS = (totalSeconds) => {
        const s = Math.max(0, totalSeconds | 0);
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        return h > 0
            ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`
            : `${m}:${String(sec).padStart(2, "0")}`;
    };

    return (
        <>
            <div className="flex justify-content-between align-items-center p-2 border-bottom-1 surface-border">
                <div className="flex align-items-center gap-3">
                    <Button
                        icon={showHeader ? "pi pi-eye-slash" : "pi pi-eye"}
                        rounded text
                        onClick={() => setShowHeader(!showHeader)}
                        size="small"
                        severity={showHeader ? "" : "secondary"}
                    />
                    {showHeader &&
                        <>
                            {/*<p className="text-lg font-bold m-0">{exam?.title}</p>*/}
                            <span className="font-bold font-mono text-700 flex align-items-center gap-2"
                                  aria-label="Current time">
                                <i className="pi pi-clock"/>
                                {now.toLocaleTimeString?.()}
                            </span>
                            <span
                                className={`font-bold font-mono flex align-items-center gap-2 ${
                                    timeLeft <= 300 ? "text-red-600" : "text-green-600"
                                }`}
                                aria-live="polite"
                                aria-label="Time left"
                                title="Time left"
                            >
                                <i className="pi pi-hourglass"/>
                                {formatHMS(timeLeft)}
                            </span>
                        </>
                }
                </div>

                {showHeader &&
                <div className="flex gap-2">
                    <Button
                        label="Anlık Durum"
                        icon="pi pi-chart-bar"
                        outlined
                        onClick={() => setShowStatus(true)}
                        size="small"
                    />
                    <Button
                        label="Gözden Geçir"
                        icon="pi pi-eye"
                        outlined
                        onClick={() => setShowReview(true)}
                        size="small"
                    />
                    <Button
                        label="Sınavı Sonlandır"
                        icon="pi pi-check"
                        outlined
                        severity="danger"
                        onClick={() => setShowFinishConfirm(true)}
                        size="small"
                    />
                </div>
                }
            </div>

            {/* Anlık Durum dialog */}
            <StatusDialog
                visible={showStatus}
                onHide={() => setShowStatus(false)}
                exam={exam}
                startedAt={startedAt}
                timeLeft={timeLeft}
                appendTo={appendTo}
            />

            {/* Gözden Geçir drawer */}
            <ReviewDrawer
                visible={showReview}
                onHide={() => setShowReview(false)}
                appendTo={appendTo}
            />

            {/* Sınavı Sonlandır confirm */}
            <Dialog
                header="Sınavı Sonlandır"
                visible={showFinishConfirm}
                style={{ width: "32rem" }}
                modal
                appendTo={appendTo}
                onHide={() => setShowFinishConfirm(false)}
                footer={
                    <div className="flex justify-content-end gap-2">
                        <Button label="İptal" outlined onClick={() => setShowFinishConfirm(false)} />
                        <Button
                            label="Sonlandır"
                            severity="danger"
                            icon="pi pi-check"
                            outlined
                            onClick={async () => {
                                setShowFinishConfirm(false);
                                try {
                                    const a = answers || {};
                                    const qids = Object.keys(a).filter((k) => typeof a[k] === "string").map(Number);
                                    await Promise.all(qids.map((qid) => persistOpenAnswer?.(qid)));
                                } catch {}
                                // persist review snapshot for finish preview
                                try {
                                    const snap = {
                                        questionHtmlOverrides: questionHtmlOverrides || {},
                                        optionHtmlOverrides: optionHtmlOverrides || {},
                                        disabledOptions: disabledOptions || {},
                                        savedAt: Date.now(),
                                    };
                                    if (studentExamId) {
                                        localStorage.setItem(`examReview:${studentExamId}`, JSON.stringify(snap));
                                    }
                                } catch {}
                                resetExam?.();
                                onFinish && onFinish();
                            }}
                        />
                    </div>
                }
            >
                <div className="p-2">
                    <p className="m-0">Sınavı sonlandırmak istediğinize emin misiniz?</p>
                </div>
            </Dialog>
        </>
    );
};

export default ExamHeader;